import cookies from "vue-cookies";
import {base_url} from "@/main";

async function customFetch(endpoint, options = {}) {
    
    const defaultOptions = {
        'method': 'POST',
        headers: {
            'Accept': 'application/json',
            
           
        },
        ...options,
    };

    const url = base_url + endpoint;

    try {
        const response = await fetch(url, defaultOptions);

        if (!response.ok) {
            if (response.status === 422) {
                throw await response.json();
            } else {
                console.log(`HTTP error! status: ${response.status}`);
                throw new Error('عملیات با موفقیت انجام نشد!');
            }
        }

        return await response.json();
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
}

export default customFetch;
